export default __webpack_public_path__ + "static/text-bottom-black-mobile-33e33ae74b1e481c0853f9616c5864dc.svg";